import { render, staticRenderFns } from "./DingDan.vue?vue&type=template&id=1d26346f&scoped=true"
import script from "./DingDan.vue?vue&type=script&lang=js"
export * from "./DingDan.vue?vue&type=script&lang=js"
import style0 from "./DingDan.vue?vue&type=style&index=0&id=1d26346f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d26346f",
  null
  
)

export default component.exports